const defaultFilters = {
    brands: [],
    brand_model: [],
    fuel_type: [],
    argerd: [1999, 2021],
    verd: [0, 20000000],
    ekinn: [0, 287000],
    girartegund: [],
    flokkar: [],
    other: [],
    vt: [],
    verdtilbod: false,
    category: [],
    sort: {
        field: "",
        order: ""
    },
    parking: false,
    companies: []
}

export default {
    carLoaded: false,
    cars: {
        scrollTop: 0,
        filters: defaultFilters,
        items: [],
        loaded: false,
    },
    asideListFirstBlock: {
        affinity: {
            title: 'Árgerð',
            type: 'slider',
            name: 'argerd',
            unit: '',
            dots: false
        },
        verd: {
            title: 'Verð',
            name: 'verd',
            type: 'slider',
            unit: 'kr.',
            dots: true
        },
        ekinn:{
            title: 'Akstur',
            name: 'ekinn',
            type: 'slider',
            unit: 'km.',
            dots: true
        }
    },
    asideList: {
        affinity: {
            title: 'Drægni',
            type: 'slider',
            name: 'affinity',
            unit: 'km.'
        },
        towing_capacity:{
            title: 'Dráttargeta',
            type: 'slider',
            name: 'towing_capacity',
            unit: 'kg.'
        },
        /*tire_size:{
            title: 'Dekkjastærð',
            name: 'tire_size',
            type: 'slider',
            unit: ''
        },*/
        /*rim_size:{
            title: 'Felgustærð',
            name: 'rim_size',
            type: 'slider',
            unit: ''
        },*/
        /*cylinders:{
            title: 'Strokkar',
            name: 'cylinders',
            type: 'slider',
            unit: ''
        },*/
        flokkar:{
            type: 'dropDown',
            title: 'Stærð og gerð',
            name: 'flokkar',
            lib: 'flokkar'
        },
        color:{
            title: 'Litatónn',
            name: 'color',
            type: 'dropDown',
            lib: 'color'
        },
        /*doors: {
            title:'Dyrafjöldi',
            name: 'doors',
            type: 'dropDown',
            lib: 'doors'
        }*/
    },
    startParams: {
        argerd: {
            min: 1999,
            max: 2022,
            filterString: 'Árgerð frá [min] til [max]',
        },
        ekinn: {
            min: 0,
            max: 300000,
            step: 10000,
            filterString:'Akstur allt að frá [min] til [max]'
        },
        verd: {
            min: 0,
            max: 20000000,
            step: 100000,
            filterString: false
        },
        affinity: {
            min: 0,
            max: 700,
            filterString: 'Drægni frá  [min] km. til [max] km. '
        },
        towing_capacity: {
            min: 0,
            max: 3500,
            filterString:'Dráttargeta frá  [min] kg. til [max] kg. ',
        },
        tire_size: {
            min: 16,
            max: 38,
            filterString:'Dekkjastærð frá  [min]″ til [max]″'
        },
        rim_size:{
            min: 16,
            max: 22,
            filterString:'Felgustærð frá  [min] til [max]'
        },
        cylinders:{
            min:1,
            max: 10,
            filterString:'Strokkar frá  [min] til [max]'
        }
    }
}
